var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhysiotherapist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Physiotherapist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6525.57-2759.13a107.52,107.52,0,0,0-107.52-107.46,107.47,107.47,0,0,0-107.46,107.46,107.48,107.48,0,0,0,107.46,107.52A107.53,107.53,0,0,0,6525.57-2759.13Z",
    transform: "translate(-6310.59 2866.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6418.05-2667.61a107.47,107.47,0,0,1-107.16-99.51c-.2,2.64-.3,5.31-.3,8a107.48,107.48,0,0,0,107.46,107.52,107.53,107.53,0,0,0,107.52-107.52c0-2.68-.1-5.35-.3-8A107.53,107.53,0,0,1,6418.05-2667.61Z",
    transform: "translate(-6310.59 2866.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6418.05-2850.59a107.53,107.53,0,0,1,107.22,99.47q.3-4,.3-8a107.52,107.52,0,0,0-107.52-107.46,107.47,107.47,0,0,0-107.46,107.46q0,4.05.3,8A107.48,107.48,0,0,1,6418.05-2850.59Z",
    transform: "translate(-6310.59 2866.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6460-2752.72h-29a16,16,0,0,1-16-16v-45a16,16,0,0,0-16-16h-32a16,16,0,0,0-16,16v93a32,32,0,0,0,32,32h77a32,32,0,0,0,32-32h0A32,32,0,0,0,6460-2752.72Zm-97.13,41a22,22,0,0,1-1.93-9v-20l44.12-44.12v16.14a25.83,25.83,0,0,0,2.91,11.92Zm42.19-102v14.83l-44.12,44.12v-31l34-34h4A6.07,6.07,0,0,1,6405.06-2813.72Zm-38.06-6.06H6381l-20,20v-13.95A6.07,6.07,0,0,1,6367-2819.78Zm1.94,116,45.25-45.25a25.8,25.8,0,0,0,16.81,6.21H6439l-44.12,44.12H6383A22,22,0,0,1,6368.94-2703.74Zm39.92,5.08,44.12-44.12h7a22,22,0,0,1,16.5,7.44l-36.67,36.68h-31Zm51.14,0h-6.14l27.52-27.51a22.23,22.23,0,0,1,.68,5.45A22.09,22.09,0,0,1,6460-2698.66Z",
    transform: "translate(-6310.59 2866.59)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiotherapist);
export default __webpack_public_path__ + "static/media/Physiotherapist.165c969f7a4ffefe3f42d925e8a55cc2.svg";
export { ForwardRef as ReactComponent };